<template>
  <div class="eimzo-component">
    <transition name="fade">
      <b-alert
        v-if="showMessage"
        :show="currentAlertCounter"
        variant="danger"
        class="custom-alert shadow-sm"
      >
        <i class="fas fa-exclamation-circle mr-2"></i> {{ alertMessage }}
      </b-alert>
    </transition>

    <div class="custom-tabs-container mb-4 shadow-sm">
      <div 
        class="custom-tab-item" 
        :class="{ active: activeTab == 1 }" 
        @click="activeTab = 1"
      >
        <i class="fas fa-file-signature mr-2"></i> {{ $t("ERI") }}
      </div>
      <div 
        class="custom-tab-item" 
        :class="{ active: activeTab == 2 }" 
        @click="activeTab = 2"
      >
        <i class="fas fa-usb-drive mr-2"></i> {{ $t("Token / ID Card") }}
      </div>
    </div>

    <div v-if="loading" class="text-center my-5 py-5">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
      <p class="mt-3 text-muted fw-bold">Ma'lumotlar yuklanmoqda...</p>
    </div>

    <div v-else>
      <template v-if="activeTab == 1">
        <div class="search-wrapper mb-4">
          <b-input-group class="shadow-sm border-0 rounded-pill overflow-hidden">
           
            <b-form-input
              v-model="search"
              :placeholder="$t('Qidirmoq...')"
              @input="searchKey"
              class="search-input border-0"
            ></b-form-input>
          </b-input-group>
        </div>

        <div v-if="keysList.length === 0" class="no-keys py-5 text-center shadow-sm rounded-lg bg-white">
          <i class="fas fa-key-skeleton fa-3x text-muted mb-3"></i>
          <h5 class="text-secondary">{{ $t("У вас нет ни одного ключа") }}</h5>
        </div>

        <b-row v-else>
          <b-col
            sm="12" md="6" lg="4"
            v-for="(item, index) in keysList"
            :key="`signkey-${index}`"
            class="mb-4"
          >
            <div 
              class="key-card shadow-soft" 
              :class="{'expired': item.expired}"
              @click="!item.expired && openSignModal(item)"
            >
              <div class="key-card-body">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div class="key-icon shadow-sm">
                    <i class="fas fa-id-card"></i>
                  </div>
                  <b-badge :class="['rounded-pill', 'px-3', item.expired ? 'text-bg-danger' : 'text-bg-success']">
                    {{ item.expired ? 'Muddati o\'tgan' : 'Faol' }}
                  </b-badge>
                </div>
                
                <h6 class="key-name text-truncate mb-2" :title="item.CN">{{ item.CN }}</h6>
                
                <div class="key-details">
                  <p><span class="label">STIR:</span> <span class="val">{{ item.TIN }}</span></p>
                  <p><span class="label">Sertifikat №:</span> <span class="val text-uppercase">{{ item.serialNumber }}</span></p>
                  <p class="text-truncate"><span class="label">Tashkilot:</span> <span class="val">{{ item.O || 'Jismoniy shaxs' }}</span></p>
                </div>

                <div class="key-date mt-3 pt-3">
                  <i class="far fa-calendar-alt mr-2 text-primary"></i>
                  {{ getDateFormat(item.validFrom) }} - {{ getDateFormat(item.validTo) }}
                </div>
              </div>
              <div class="key-card-footer border-0">
                <button class="btn-select shadow-sm" :disabled="item.expired">
                  {{ item.expired ? 'Amal qilish muddati tugagan' : 'Tanlash' }}
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </template>

      <template v-if="activeTab == 2">
        <b-row v-if="TokenList.length > 0 || BaikList.length > 0">
          <b-col sm="12" md="6" lg="4" v-for="(token, tIdx) in TokenList" :key="'tok-'+tIdx" class="mb-4">
            <div class="key-card token-card shadow-soft" @click="signToken('idcard', token)">
              <div class="key-card-body text-center">
                <div class="key-icon token mx-auto shadow-sm"><i class="fas fa-microchip"></i></div>
                <h6 class="key-name mt-3">ID-Card (Token)</h6>
                <p class="text-muted small mb-0">{{ token }}</p>
              </div>
              <div class="key-card-footer border-0">
                <button class="btn-select shadow-sm btn-token" :disabled="loadingButton">
                  <b-spinner small v-if="loadingButton"></b-spinner>
                  Ulanish
                </button>
              </div>
            </div>
          </b-col>
          </b-row>
        <div v-else class="no-keys py-5 text-center shadow-sm rounded-lg bg-white">
          <i class="fas fa-usb-drive fa-3x text-muted mb-3"></i>
          <h5 class="text-secondary">{{ $t("У вас нет электронного токена") }}</h5>
        </div>
      </template>
    </div>

    <b-modal
      v-model="signModal"
      centered
      hide-header
      hide-footer
      body-class="p-0 border-0 overflow-hidden shadow-lg"
      content-class="custom-modal-content border-0"
    >
      <div class="modal-header-custom border-0 shadow-sm">
        <h5 class="m-0 font-weight-bold"><i class="fas fa-signature mr-2"></i>Hujjatni tasdiqlash</h5>
        <span @click="signModal = false" class="close-icon">&times;</span>
      </div>
      <div class="modal-body-custom p-5">
        <div class="text-center mb-4">
          <div class="modal-confirm-icon shadow-soft">
            <i class="fas fa-check-double"></i>
          </div>
          <p class="mt-4 text-muted fs-16">Siz tanlagan kalit bilan imzolashni tasdiqlaysizmi?</p>
          <div class="selected-key-name px-3 py-2 rounded shadow-sm border">
             {{ currentItem ? currentItem.CN : '' }}
          </div>
        </div>
        
        <div class="d-flex justify-content-center mt-4">
          <button class="btn-custom btn-cancel mr-3 shadow-sm" @click="signModal = false">
            {{ $t("no") }}
          </button>
          <button class="btn-custom btn-confirm shadow-sm" @click="signByEimzo" :disabled="loadingButton">
            <b-spinner small v-if="loadingButton" class="mr-2"></b-spinner>
            {{ $t("yes") }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// Logic qismi o'zgarishsiz qoldi (o'tgan javobdagi kabi)
import EIMZOClient from "../plugins/e-imzo-client.js";
import AppSettings from "./settings.json";
import { BCard, BAlert, BRow, BCol, BSpinner, BModal, BFormInput, BInputGroup, BInputGroupPrepend, BBadge } from "bootstrap-vue";

export default {
  name: "JustSign",
  props: { dataToSign: { default: null,required: false ,type:Object} },
  components: { BCard, BAlert, BRow, BCol, BSpinner, BModal, BFormInput, BInputGroup, BInputGroupPrepend, BBadge },
  data() {
    return {
      activeTab: 1, search: "", loading: false, loadingButton: false, signModal: false,
      keysList: [], allKeysList: [], TokenList: [], BaikList: [],
      currentItem: null, alertMessage: null, showMessage: false, currentAlertCounter: 5
    };
  },
  methods: {
    // ... avvalgi javobdagi appLoad, uiLoadKeys, signByEimzo va boshqa metodlar ...
    appLoad() {
      let vm = this; vm.loading = true; EIMZOClient.API_KEYS = AppSettings.api_keys;
      EIMZOClient.checkVersion((major, minor) => {
          if (parseInt(major) * 100 + parseInt(minor) < 337) {
            vm.loading = false; vm.uiShowMessage("E-IMZO yangilang", "danger");
          } else {
            EIMZOClient.installApiKeys(() => { vm.loading = false; vm.uiLoadKeys(); vm.idCardIsPLuggedIn(); },
            (e, r) => { vm.loading = false; vm.uiShowMessage(r || e, "danger"); });
          }
      }, (e, r) => { vm.loading = false; vm.uiShowMessage(r || e, "danger"); });
    },
    uiLoadKeys() {
      let vm = this; vm.keysList = []; vm.allKeysList = [];
      EIMZOClient.listAllUserKeys((o, i) => "itm-" + o.serialNumber + "-" + i,
        (itemId, v) => vm.uiCreateItem(itemId, v), () => {},
        (e, r) => vm.uiShowMessage("Drayver xatosi", "danger"));
    },
    uiCreateItem(itmkey, vo) {
      vo.expired = new Date(vo.validTo).getTime() < new Date().getTime();
      this.keysList.push(vo); this.allKeysList.push(vo);
      return document.createElement("option");
    },
    idCardIsPLuggedIn() {
      if (typeof CAPIWS === "undefined") return;
      CAPIWS.callFunction({ plugin: "idcard", name: "list_readers" }, (event, data) => { if (data.success) this.TokenList = data.readers; });
      CAPIWS.callFunction({ plugin: "baikey", name: "list_tokens" }, (event, data) => { if (data.success) this.BaikList = data.tokens; });
    },
    async signByEimzo() {
      this.loadingButton = true; const vm = this;
      try {
        let keyId = await new Promise((resolve, reject) => { EIMZOClient.loadKey(vm.currentItem, (id) => resolve(id), (e, r) => reject(r || e)); });
        EIMZOClient.createPkcs7(keyId, JSON.stringify(this.dataToSign || {}), "", (pkcs7) => {
            vm.$emit("sign", { key: pkcs7, data: vm.currentItem }); vm.signModal = false; vm.loadingButton = false;
        }, (e, r) => { vm.uiShowMessage(r || e, "danger"); vm.loadingButton = false; });
      } catch (err) { vm.uiShowMessage(err, "danger"); vm.loadingButton = false; }
    },
    async signToken(type, deviceName) {
      this.loadingButton = true; const vm = this;
      var dataB64 = Base64.encode(JSON.stringify(vm.dataToSign || {}));
      CAPIWS.callFunction({ plugin: "pkcs7", name: "create_pkcs7", arguments: [dataB64, type, 'no'] }, (event, data) => {
        if (data.success) {
          vm.$emit("sign", { key: data.pkcs7_64, type: type }); vm.loadingButton = false;
        } else { vm.uiShowMessage(data.reason || "Imzolashda xatolik", "danger"); vm.loadingButton = false; }
      }, (e) => { vm.uiShowMessage(e, "danger"); vm.loadingButton = false; });
    },
    searchKey(val) {
      this.keysList = this.allKeysList.filter(el => el.CN.toLowerCase().includes(val.toLowerCase()) || el.TIN.includes(val));
    },
    openSignModal(item) { this.currentItem = item; this.signModal = true; },
    getDateFormat(date) { let d = new Date(date); return `${d.getDate().toString().padStart(2, '0')}.${(d.getMonth() + 1).toString().padStart(2, '0')}.${d.getFullYear()}`; },
    uiShowMessage(message, variant) { this.alertMessage = message; this.showMessage = true; setTimeout(() => { this.showMessage = false; }, 5000); }
  },
  created() { this.appLoad(); }
};
</script>

<style scoped>
.eimzo-component { font-family: 'Inter', 'Segoe UI', sans-serif; background: #fcfcfc; padding: 10px; }

/* Shadow turlari */
.shadow-soft { box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05); }
.shadow-strong { box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1); }

/* Tabs */
.custom-tabs-container { display: flex; background: #fff; padding: 6px; border-radius: 15px; border: 1px solid #edf2f7; }
.custom-tab-item { flex: 1; text-align: center; padding: 12px; cursor: pointer; border-radius: 12px; font-weight: 600; transition: 0.3s; color: #718096; }
.custom-tab-item.active { background: #007bff; color: #fff; box-shadow: 0 8px 15px rgba(0, 123, 255, 0.3); }

/* Card Dizayni */
.key-card { background: #fff; border: 1px solid #edf2f7; border-radius: 20px; transition: 0.4s; height: 100%; display: flex; flex-direction: column; overflow: hidden; }
.key-card:hover { transform: translateY(-8px); box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08); border-color: #007bff; }
.key-card.expired { opacity: 0.7; cursor: not-allowed; background: #f8f9fa; }

.key-card-body { padding: 25px; flex: 1; }
.key-icon { width: 50px; height: 50px; background: #f0f7ff; color: #007bff; display: flex; align-items: center; justify-content: center; border-radius: 15px; font-size: 1.4rem; }
.key-name { font-weight: 800; font-size: 1.05rem; color: #1a202c; line-height: 1.4; }

.key-details p { margin-bottom: 8px; font-size: 0.9rem; display: flex; justify-content: space-between; }
.key-details .label { color: #a0aec0; font-weight: 500; }
.key-details .val { color: #4a5568; font-weight: 600; }

.key-date { border-top: 1px dashed #e2e8f0; font-size: 0.85rem; color: #718096; font-weight: 500; }

.key-card-footer { padding: 20px; background: #fff; }
.btn-select { width: 100%; padding: 12px; border: none; background: #007bff; color: white; border-radius: 12px; font-weight: 700; transition: 0.3s; }
.btn-select:hover:not(:disabled) { background: #0056b3; transform: scale(1.02); }

/* Modal Customizatsiya */
.custom-modal-content { border-radius: 24px !important; }
.modal-header-custom { background: #007bff; color: white; padding: 20px 25px; display: flex; justify-content: space-between; align-items: center; }
.modal-confirm-icon { width: 80px; height: 80px; background: #ebf8ff; color: #3182ce; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto; font-size: 2.2rem; }
.selected-key-name { background: #f7fafc; color: #2d3748; font-weight: 700; font-size: 1.1rem; }

.btn-custom { padding: 12px 35px; border-radius: 14px; font-weight: 700; border: none; transition: 0.2s; }
.btn-confirm { background: #38a169; color: white; }
.btn-confirm:hover { background: #2f855a; }
.btn-cancel { background: #edf2f7; color: #4a5568; }
.btn-cancel:hover { background: #e2e8f0; }

.fs-16 { font-size: 16px; }
.close-icon { cursor: pointer; font-size: 28px; transition: 0.2s; }
.close-icon:hover { opacity: 0.7; }
</style>